import React from "react";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import TextField from "material-ui/TextField";
import Input, { InputLabel, InputAdornment } from "material-ui/Input";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import { FormControl, FormHelperText } from "material-ui/Form";
//import InputAdornment from "material-ui/InputAdornment";

import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";

import { validateFormData } from "../../../common/formtool";

class NewDevice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      device: {
        deviceType: "",
        serialnumber: "",
        toDiplaySerialNumber: ""
      },
      showSerialNumber: false,
      errors: {}
    };
    this.onChange = this.onChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onChange(e) {
    let device = { ...this.state.device };
    device[e.target.name] = e.target.value;
    device["toDiplaySerialNumber"] = e.target.value;
    this.setState({
      device: device,
      errors: {}
    });
  }

  onDeviceTypeChange(e) {
    //const serialnoprefix = this.props.deviceTypes.find(o => o.name.includes(e.target.value))
    this.setState({
      showSerialNumber: true,
      device: {
        deviceType: e.target.value,
        serialnumber: "",
        toDiplaySerialNumber: "",
        deviceValidation:
          this.props.deviceTypes.find(o => o.name.includes(e.target.value))
            .serialnoprefix || null
      }
    });
  }

  handleClose(e) {
    this.props.close();
  }

  handleSubmit() {
    let { translate } = this.props;
    let device = { ...this.state.device };

    device["serialnumber"] = device.serialnumber.startsWith(
      device.deviceValidation
    )
      ? device.serialnumber
      : device.deviceValidation + device.serialnumber;
    this.setState(
      {
        device: device
      },
      function() {
        let errors = validateFormData(this.state.device, {
          serialnumber: {
            required: translate("formfield_error_general_required"),
            pattern: {
              value: /^(157|163|166|158)[0-9a-z]{5,5}\/[0-9a-z]{8,8}$/gi,
              message: translate("formfield_error_device_general_pattern")
            }
          }
        });
        if (Object.keys(errors).length) {
          this.setState({ errors: errors });
        } else {
          this.props.submit({ ...this.state.device });
        }
      }.bind(this)
    );
  }

  render() {
    const { translate, classes, deviceTypes } = this.props;

    const { device, errors, error, showSerialNumber } = this.state;

    return (
      <Modal open={true} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography
                type="headline"
                color="inherit"
                className={classes.modalHeader}
              >
                {translate("device_add_title")}
              </Typography>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>
            <ModalContents>
              <form noValidate autoComplete="off" className={classes.form}>
                <FormControl
                  className={classes.textField}
                  margin="normal"
                  error={errors.deviceid}
                >
                  <InputLabel htmlFor="device" required>
                    {translate("device_type")}
                  </InputLabel>
                  <Select
                    value={device.deviceType}
                    onChange={e => this.onDeviceTypeChange(e)}
                    input={
                      <Input
                        name="deviceType"
                        id="deviceType"
                        value={device.deviceType}
                        defaultValue={device.deviceType}
                      />
                    }
                    fullWidth
                  >
                    {deviceTypes
                      ? deviceTypes.map((device, index) => {
                          return (
                            <MenuItem key={index} value={device.id}>
                              {translate(device.id)}
                            </MenuItem>
                          );
                        })
                      : null}
                  </Select>
                  <FormHelperText>
                    {translate("job_device_help")}
                  </FormHelperText>
                </FormControl>
                {showSerialNumber && (
                  <TextField
                    required
                    error={errors.serialnumber ? true : false}
                    name="serialnumber"
                    label={translate("device_serialnumber")}
                    margin="normal"
                    fullWidth
                    value={device.toDiplaySerialNumber}
                    onChange={this.onChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" variant="filled">
                          <div
                            style={{
                              backgroundColor: "#D3D4D0",
                              padding: "4px 5px 5px 5px",
                              color: "#000000"
                            }}
                          >
                            {device.deviceValidation}
                          </div>
                        </InputAdornment>
                      )
                    }}
                    helperText={
                      errors.serialnumber
                        ? errors.serialnumber
                        : translate("device_serialnumber_help1") +
                          device.deviceValidation +
                          ". " +
                          translate("device_serialnumber_help2")
                    }
                  />
                )}
              </form>
            </ModalContents>
            <ModalFooter>
              <Button
                raised
                color="accent"
                className={classes.submit}
                onClick={this.handleSubmit}
                type="submit"
              >
                {translate("general_submit")}
              </Button>
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    );
  }
}
export default withStyles(styles)(NewDevice);



// WEBPACK FOOTER //
// ./src/components/devices/new/index.js